import React, { useContext, useState, useEffect } from 'react';
import styles from './Frontpage.module.scss';
import { SettingsContext } from '../../contexts/settings-provider';

import emojiList from '../../data/emoji.json';

import Main from '../../components/Main/Main';
import Section from '../../components/Section/Section';
import Button from '../../components/Button/Button';
import Logo from '../../components/Logo/Logo';
import ProfileLink from '../../components/ProfileLink/ProfileLink';

const Frontpage = () => {
  const [settings] = useContext(SettingsContext);
  const [signedIn, setSignedIn] = useState(false);

  useEffect(() => {
    if (settings.user) {
      setSignedIn(true);
    } else {
      setSignedIn(false);
    }
  }, [settings.user]);

  return (
    <Main>
      <Section>
        {signedIn && <ProfileLink className={styles.profile} />}
        <Logo />
        <p className={styles.description}>
          An AR game using AI and your camera to detect emojis (or rather their
          real-world counterparts) in the wild. Can you catch all{' '}
          {emojiList.length}?🥵
        </p>
        {signedIn ? (
          <div className={styles.actions}>
            <Button link={'/play'}>Back to game</Button>
            <Button link={'/score'} alternative>
              Highscore
            </Button>
          </div>
        ) : (
          <div className={styles.actions}>
            <Button
              link={{
                pathname: '/play',
                hash: '#signIn',
              }}
            >
              Sign in
            </Button>
            <Button
              alternative
              link={{
                pathname: '/play',
                hash: '#register',
              }}
            >
              Create account
            </Button>
          </div>
        )}
      </Section>
    </Main>
  );
};

export default Frontpage;
